var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAutoFixHighSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "auto_fix_high"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 5.5L13.6275 4.12667L15.0008 3.5L13.6275 2.87333L13.0008 1.5L12.3742 2.87333L11.0008 3.5L12.3742 4.12667L13.0008 5.5Z",
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33418 5.5L5.96084 4.12667L7.33418 3.5L5.96084 2.87333L5.33418 1.5L4.70751 2.87333L3.33418 3.5L4.70751 4.12667L5.33418 5.5Z",
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 9.16667L12.3742 10.54L11.0008 11.1667L12.3742 11.7933L13.0008 13.1667L13.6275 11.7933L15.0008 11.1667L13.6275 10.54L13.0008 9.16667Z",
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4742 6.91333L9.58751 5.02667C9.45418 4.9 9.28751 4.83333 9.11418 4.83333C8.94084 4.83333 8.77418 4.9 8.64084 5.02667L1.19418 12.4733C0.934176 12.7333 0.934176 13.1533 1.19418 13.4133L3.08084 15.3C3.21418 15.4333 3.38084 15.5 3.55418 15.5C3.72751 15.5 3.89418 15.4333 4.02751 15.3067L11.4742 7.86C11.7342 7.6 11.7342 7.17333 11.4742 6.91333ZM9.11418 6.44667L10.0542 7.38667L9.27418 8.16667L8.33418 7.22667L9.11418 6.44667ZM3.55418 13.8933L2.61418 12.9533L7.39418 8.16667L8.33418 9.10667L3.55418 13.8933Z",
    fill: "#25292E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutoFixHighSm);
export default __webpack_public_path__ + "static/media/icon_auto_fix_high_sm.d24a383c3560cce2662ba7f6fbdb79b6.svg";
export { ForwardRef as ReactComponent };